module.exports = __webpack_public_path__ + "img/network-error.3ebcc7fa.png";